export default () => {
	const urlArr = window.location.search.substring(1).split('&')
	const modeObj = {}
	urlArr.forEach(item => {
		const name = item.substring(0, item.indexOf('='))
		let value = item.substring(item.indexOf('=') + 1)
		value = decodeURIComponent(value)
		modeObj[name] = value
	})
	return modeObj
}
